import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { GridDataSource } from "../data-grid/data-grid.datasource";
import { DataGridComponent } from "../data-grid/data-grid.interface";
import { DataGridService } from "../data-grid/data-grid.service.interface";
import { ServiceSummaryDTO } from "../dto-models/serviceSummaryDTO.model";
import { DataGridColumn } from "../models/dataGridColumn.model";

@Component({
    selector: "bs-service-add",
    templateUrl: "./service-add.component.html",
    styleUrls: ["./service-add.component.scss"],
    standalone: false
})
export class ServiceAddComponent
  implements DataGridComponent<ServiceSummaryDTO>, OnInit
{
  dataSource: GridDataSource<ServiceSummaryDTO>;
  dataGridService: DataGridService<ServiceSummaryDTO>;
  existingServices: ServiceSummaryDTO[];
  existingServiceIds: number[];

  columns: DataGridColumn[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private dialogRef: MatDialogRef<ServiceAddComponent>,
  ) {
    this.dataGridService = data.gridService;
    this.existingServices = data.existingServices;
    this.existingServiceIds = this.existingServices.map(
      (service) => service.id,
    );

    this.columns = [
      {
        property: "checkbox",
        visible: true,
        sticky: true,
      },
      {
        name: this.translate.instant("SERVICE.COLUMNS.SERVICENAME"),
        property: "serviceName",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.4",
      },
      {
        name: this.translate.instant("SERVICE.COLUMNS.PARENTSERVICE"),
        property: "parentService",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.4",
      },
      {
        name: this.translate.instant("SERVICE.COLUMNS.CATEGORYNAME"),
        property: "categoryName",
        visible: true,
        isModelProperty: true,
        sortable: true,
        flexGrow: "0.4",
      },
    ] as DataGridColumn[];
  }

  ngOnInit(): void {
    this.dataSource = new GridDataSource<ServiceSummaryDTO>(
      this.dataGridService,
    );

    this.setDataSource();
  }

  saveAndClose(): void {
    const checkedServices = this.dataSource?.selectedRowIds?.map(Number);
    var selectedServices = this.existingServices.filter((service) =>
      checkedServices.includes(service.id),
    );
    selectedServices = selectedServices.concat(
      this.dataSource.selectedDataSourceRows,
    );
    this.dialogRef.close(selectedServices);
  }

  close(): void {
    this.dialogRef.close(undefined);
  }

  setDataSource(): void {
    const filter: DataGridColumn[] = [
      <DataGridColumn>{
        property: "status",
        filterValue: 3,
      },
    ];

    if (this.data.locationTypeId) {
      filter.push(<DataGridColumn>{
        property: "locationTypeId",
        filterValue: this.data.locationTypeId,
      });
    }

    if (this.data.locationId) {
      filter.push(<DataGridColumn>{
        property: "locationId",
        filterValue: this.data.locationId,
      });
    }

    if (this.data.buildingId) {
      filter.push(<DataGridColumn>{
        property: "buildingId",
        filterValue: this.data.buildingId,
      });
    }

    if (this.data.serviceId) {
      filter.push(<DataGridColumn>{
        property: "thisServiceId",
        filterValue: this.data.serviceId,
      });
    }

    this.dataSource.filter = filter;
  }

  openColumnsPanel(dataGrid: { filterOpen: boolean }): void {
    dataGrid.filterOpen = !dataGrid.filterOpen;
  }
}
